import { useEffect, useState } from 'react';
import { siteConfig } from '../../../shared/config/site';

/**
 * On phones the clinic phone number is the whole conversion, and it leaves the
 * screen with the hero. This keeps it one thumb away for the rest of the page.
 */
export function MobileCallBar() {
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setRevealed(window.scrollY > window.innerHeight * 0.75);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-50 border-t border-neutral-200 bg-[rgba(245,247,245,0.96)] px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-md transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] lg:hidden ${
        revealed ? 'translate-y-0' : 'translate-y-full'
      }`}
      aria-hidden={!revealed}
    >
      <div className="flex items-stretch gap-2.5">
        <a
          href={siteConfig.phoneHref}
          tabIndex={revealed ? undefined : -1}
          className="flex min-h-[48px] flex-1 items-center justify-center gap-2 rounded-lg bg-primary-600 px-5 font-body text-[0.9375rem] font-medium text-bone transition-colors hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M5.2 2.5 6.6 5.3 5.2 6.7c.6 1.4 1.7 2.5 3.1 3.1l1.4-1.4 2.8 1.4v2.3c0 .6-.5 1.1-1.1 1C6.2 12.6 3.4 9.8 2.6 4.6c-.1-.6.4-1.1 1-1.1h1.6Z"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinejoin="round"
            />
          </svg>
          Call {siteConfig.phoneDisplay}
        </a>
        <a
          href={siteConfig.mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={revealed ? undefined : -1}
          className="flex min-h-[48px] items-center justify-center rounded-lg border border-neutral-300 px-5 font-body text-[0.9375rem] font-medium text-ink transition-colors hover:border-neutral-400 hover:bg-neutral-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
        >
          Directions
        </a>
      </div>
    </div>
  );
}
